var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.8847,
    height: 23.9995,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6329 7.60942C19.7441 7.25813 19.6329 7 19.1035 7H17.3531C16.908 7 16.7029 7.22299 16.5916 7.46888C16.5916 7.46888 15.7014 9.5239 14.4404 10.8588C14.0325 11.2452 13.847 11.3681 13.6245 11.3681C13.5132 11.3681 13.3521 11.2452 13.3521 10.8939V7.60942C13.3521 7.18787 13.223 7 12.8521 7H10.1014C9.82329 7 9.65602 7.19565 9.65602 7.38108C9.65602 7.78069 10.2865 7.87285 10.3515 8.99698V11.4384C10.3515 11.9737 10.2494 12.0707 10.0269 12.0707C9.43349 12.0707 7.99005 10.0065 7.13395 7.64454C6.96618 7.18545 6.79791 7 6.35055 7H4.60014C4.10003 7 4 7.22299 4 7.46888C4 7.908 4.59343 10.086 6.76309 12.9665C8.20953 14.9337 10.2475 16 12.1019 16C13.2145 16 13.3522 15.7632 13.3522 15.3552V13.8684C13.3522 13.3947 13.4576 13.3002 13.8099 13.3002C14.0695 13.3002 14.5146 13.4231 15.5531 14.3716C16.7399 15.4957 16.9356 16 17.6032 16H19.3536C19.8537 16 20.1037 15.7632 19.9595 15.2958C19.8016 14.8299 19.235 14.1541 18.4831 13.3529C18.0751 12.8962 17.4632 12.4044 17.2777 12.1585C17.0181 11.8424 17.0923 11.7018 17.2777 11.4208C17.2777 11.4208 19.4103 8.57543 19.6329 7.60942Z",
    fill: "#80899C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.cdd5fd8f4b6a733a2c7be65ea04cb193.svg";
export { ForwardRef as ReactComponent };